import { useDispatch } from 'react-redux';
import { createOfferCalculatorStore } from '../redux';

export type AppDispatch = ReturnType<typeof createOfferCalculatorStore>['dispatch'];

export const useAppDispatch: () => AppDispatch = useDispatch;
